import {Image, Pressable, View} from "react-native"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import HappyDog from "./happy-dog.png"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import {Text} from "shared/base"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class ComponentsPlansSignUpModalStepSuccess extends ShapeComponent {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.plans.sign_up_modal.step_success"})

    this.t = t
  }

  render() {
    const {t} = this.tt

    return (
      <View
        dataSet={this.rootDataSet ||= {component: "plans--sign-up-modal--step-success"}}
        style={this.rootStyle ||= {
          alignItems: "center",
          justifyContent: "center",
          padding: 32,
          paddingBottom: 0,
          position: "relative",
          minHeight: "100vh",
          width: "100%"
        }}
      >
        <View
          style={this.layoutStyle ||= {
            alignItems: "center",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            maxWidth: 1100,
            width: "100%"
          }}
        >
          <View
            style={this.cardStyle ||= {
              backgroundColor: "#ffffff",
              borderRadius: 48,
              boxShadow: "0 24px 60px rgba(44, 44, 150, 0.15)",
              margin: 24,
              maxWidth: 520,
              paddingBottom: 40,
              paddingLeft: 40,
              paddingRight: 40,
              paddingTop: 40,
              width: "100%"
            }}
          >
            <Text
              style={this.cardLabelStyle ||= {
                color: "#87a2d5",
                fontFamily: "HankenGrotesk",
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 2,
                marginBottom: 12,
                textTransform: "uppercase"
              }}
            >
              {t(".upgrade_complete")}
            </Text>
            <Text
              style={this.cardTitleStyle ||= {
                color: "#2c2c96",
                fontFamily: "HankenGrotesk",
                fontSize: 28,
                fontWeight: 700,
                marginBottom: 12
              }}
            >
              {t(".thank_you_for_your_order")}
            </Text>
            <Text
              style={this.cardBodyStyle ||= {
                color: "#2c2c96",
                fontFamily: "HankenGrotesk",
                fontSize: 16,
                lineHeight: 24,
                marginBottom: 12
              }}
            >
              {t(".we_will_send_the_invoice_to_the_given_email")}
            </Text>
            <Text style={this.cardBodyStyle}>
              {t(".the_upgrade_is_now_active")}
            </Text>
            <Pressable
              dataSet={this.closeWindowButtonDataSet ||= {class: "close-window-button"}}
              onClick={this.p.onRequestClose}
              onMouseDown={this.p.onRequestClose}
              onPress={this.p.onRequestClose}
              onTouchStart={this.p.onRequestClose}
              style={this.closeWindowButtonStyle ||= {
                alignSelf: "center",
                backgroundColor: "#5253ff",
                borderRadius: 22,
                marginTop: 16
              }}
            >
              <Text
                style={this.closeWindowButtonFontStyle ||= {
                  color: "#fff",
                  fontFamily: "HankenGrotesk",
                  fontSize: 16,
                  fontWeight: 600,
                  marginBottom: 12,
                  marginLeft: 32,
                  marginRight: 32,
                  marginTop: 12,
                  textAlign: "center"
                }}
              >
                {t(".close_window")}
              </Text>
            </Pressable>
          </View>
        </View>
        <View
          style={this.dogSpeechWrapStyle ||= {
            alignItems: "center",
            position: "absolute",
            right: 60,
            bottom: -32,
            zIndex: 1
          }}
        >
          <View
            style={this.bubbleWrapStyle ||= {
              alignItems: "center",
              marginBottom: 12,
              maxWidth: 360,
              width: "100%"
            }}
          >
            <View
              style={this.bubbleStyle ||= {
                backgroundColor: "#1b1f72",
                borderRadius: 32,
                paddingBottom: 32,
                paddingLeft: 28,
                paddingRight: 28,
                paddingTop: 32,
                position: "relative",
                width: "100%"
              }}
            >
              <Text
                style={this.bubbleTextStyle ||= {
                  color: "#ffffff",
                  fontFamily: "HankenGrotesk",
                  fontSize: 32,
                  fontStyle: "italic",
                  fontWeight: 700,
                  lineHeight: 36,
                  textAlign: "center"
                }}
              >
                {t(".awesome_you_are_such_a_pro")}
              </Text>
              <View
                style={this.bubbleTailStyle ||= {
                  backgroundColor: "#1b1f72",
                  borderRadius: 6,
                  bottom: -12,
                  height: 24,
                  position: "absolute",
                  right: 64,
                  transform: [{rotate: "45deg"}],
                  width: 24
                }}
              />
            </View>
          </View>
          <Image
            source={HappyDog}
            style={this.dogStyle ||= {
              height: 220,
              width: 260
            }}
          />
        </View>
      </View>
    )
  }
}))
